import {useState} from 'react'
import {citySelector} from "../../Slices/ticketslice";
import {useSelector} from "react-redux";
import {ArrowDropDown} from '@mui/icons-material'



const NavbarDropDown = () => {






    const [show, setShow] = useState(false)


    // getting data from redux and displaying cities
    const dataneeded =        [
        {
            id: 1,
            name: 'ارومیه'
        },
        {
            id: 2,
            name: 'تبریز'
        },
        {
            id: 3,
            name: 'تهران'
        },
        {
            id: 4,
            name: 'اصفهان'
        },
        {
            id: 5,
            name: 'مشهد'
        },
        {
            id: 11,
            name: 'شیراز'
        },
        {
            id: 13,
            name: 'اردبیل'
        }
    ]
    const status = useSelector((state) => (state.ticket.status))


    let citiesList
    if (dataneeded) {
        citiesList = dataneeded.map((item) => (

            <button key={item.id} onClick={() => {
                localStorage.setItem('city', JSON.stringify(item));
                setShow(false)
                window.location.reload()
            }} className="button noborder wdith100 clrseven pinar is-block navbardropwdownhover has-text-white">
                {item.name}
            </button>
        ))

    } else {
        citiesList = <p className='has-text-white'>...</p>
    }


    let Selectedcity
    if (localStorage.getItem('city')) {
        Selectedcity = JSON.parse(localStorage.getItem('city')).name


    }else {
        Selectedcity=
            <>

                 شهر ها       <ArrowDropDown />
            </>
    }


    return (
        <>


            <div className={`dropdown ${show && 'is-active'}`}>
                <div className="dropdown-trigger">
                    <button onClick={() => setShow(!show)} className="button pinar clrseven has-text-white"
                            aria-haspopup="true" aria-controls="dropdown-menu3" style={{borderRadius:0}}>
                        <span className='is-flex flex-JCS-ACS'>{Selectedcity}</span>

                    </button>
                </div>
                <div className="dropdown-menu " id="dropdown-menu3" role="menu">
                    <div className="dropdown-content clrseven">


                        <button onClick={() => {
                            localStorage.removeItem('city')
                            setShow(false)
                            window.location.reload()
                        }}
                                className="button noborder wdith100 clrseven pinar is-block navbardropwdownhover has-text-white">
                             شهر ها

                        </button>

                        {
                            citiesList
                        }

                    </div>
                </div>
            </div>

        </>

    )
}
export default NavbarDropDown;